import { LEAVE_TYPES } from '../../constants';
import { deleteAbsence, insertAbsence, saveAbsenceDecision } from '../../services/absences';
import { notify } from '../../store/feedback';
import { refreshAbsences } from './refresh';

export default function absencesRequestsHandlers(deps, api) {
  const { session } = deps;

  // Enregistre une absence pour un dev donné (devId = id app = id user Supabase pour un vrai compte).
  // Workflow de validation : personne ne valide sa propre demande, jamais — même un manager/valideur.
  // Un manager qui saisit une absence pour quelqu'un D'AUTRE depuis Équipe est déjà l'autorité de
  // validation — acceptée immédiatement, comme avant. Toute demande pour SOI-MÊME (quel que soit le
  // rôle) crée une demande "en attente" : pas de feuille d'heures générée tant qu'elle n'est pas
  // validée par quelqu'un d'autre, pour ne jamais compter par avance un congé qui pourrait être refusé.
  async function saveAbsence(devId, userId, { type, debut, debut_half, fin, fin_half }) {
    const isSelf = userId === session.user.id;
    // Congé payé, maladie, congé exceptionnel et sans solde demandent une validation (LEAVE_TYPES) ;
    // cours et temps partiel sont acceptés automatiquement quel que soit qui les saisit.
    const needsValidation = LEAVE_TYPES.includes(type) && isSelf;
    const statut = needsValidation ? 'attente' : 'acceptee';
    const { data, error } = await insertAbsence(
      { userId, devId, type, debut, debut_half, fin, fin_half, statut },
      isSelf ? null : session.user.id,
    );
    if (error) {
      notify('Erreur enregistrement absence : ' + error.message);
      return;
    }
    if (statut === 'acceptee') await api.syncAbsenceTimesheets(data, userId);
    else api.notifyAbsenceRequested(data);
    await refreshAbsences(deps, api);
  }

  // Valide ou refuse une demande en attente. N'écrit des feuilles d'heures qu'à l'acceptation —
  // jamais avant, pour ne pas compter un congé encore incertain. Personne ne peut décider de sa
  // propre demande (le bouton est déjà caché pour ce cas, ce garde-fou double le trigger côté base).
  async function decideAbsence(absence, accept) {
    if (absence.user_id === session.user.id) return;
    const statut = accept ? 'acceptee' : 'refusee';
    const { data, error } = await saveAbsenceDecision(absence, session, statut);
    if (error) {
      notify('Erreur validation : ' + error.message);
      return;
    }
    if (accept) await api.syncAbsenceTimesheets(data, absence.user_id);
    api.notifyAbsenceDecided(data, accept);
    await refreshAbsences(deps, api);
  }

  // Annule/supprime une absence. Si c'est le demandeur qui annule sa propre demande (en attente ou
  // déjà acceptée), les valideurs de congés sont prévenus par e-mail — pas de notification quand
  // c'est un valideur/manager qui supprime la demande de quelqu'un d'autre (action admin volontaire).
  async function removeAbsence(absence) {
    const isSelf = absence.user_id === session.user.id;
    await api.deleteAbsenceTimesheets(absence);
    const { error } = await deleteAbsence(absence);
    if (error) {
      notify('Erreur suppression : ' + error.message);
      return;
    }
    if (isSelf) api.notifyAbsenceCancelled(absence);
    await refreshAbsences(deps, api);
  }

  return { saveAbsence, decideAbsence, removeAbsence };
}
